"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simulator = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _modal = require("@creditas-lab/modal");

var _reactQuery = require("react-query");

var _ProductInstallmentsStep = require("./components/ProductInstallmentsStep");

var _IntendedCreditStep = require("./components/IntendedCreditStep");

var _Stepper = require("./components/Stepper");

var _SimulationWrapper = require("./components/SimulationWrapper");

var _hooks = require("./hooks");

var _utils = require("./utils");

var _constants = require("./constants");

var _services = require("./services");

require("@formatjs/intl-numberformat/polyfill");

require("@formatjs/intl-numberformat/locale-data/pt");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  open: _propTypes.bool.isRequired
} : {};

const Simulator = ({
  open
}) => {
  const {
    interestRateType,
    closeSimulator
  } = (0, _hooks.useSimulator)();
  const queryClient = new _reactQuery.QueryClient();

  const onStepChange = currentStep => {
    (0, _services.dispatchPageViewEvent)((0, _utils.addPrefix)('/', currentStep));
  };

  (0, _react.useEffect)(() => {
    if (open) {
      (0, _services.dispatchInterestRateTypeEvent)(interestRateType.toLowerCase());
    }
  }, [open]);
  return (0, _core.jsx)(_reactQuery.QueryClientProvider, {
    client: queryClient
  }, (0, _core.jsx)(_modal.Modal, {
    id: "simulation-modal",
    open: open,
    onClose: closeSimulator
  }, (0, _core.jsx)(_SimulationWrapper.SimulationWrapper.Cross, null, (0, _core.jsx)(_Stepper.Stepper, {
    onChange: onStepChange
  }, (0, _core.jsx)(_Stepper.Step, {
    name: _constants.Steps.IntendedCredit
  }, (0, _core.jsx)(_IntendedCreditStep.IntendedCreditStep, null)), (0, _core.jsx)(_Stepper.Step, {
    name: _constants.Steps.ProductInstallments
  }, (0, _core.jsx)(_ProductInstallmentsStep.ProductInstallmentsCrossStep, null)))), (0, _core.jsx)(_SimulationWrapper.SimulationWrapper.ByProduct, null, (0, _core.jsx)(_Stepper.Stepper, {
    onChange: onStepChange
  }, (0, _core.jsx)(_Stepper.Step, {
    name: _constants.Steps.ProductInstallments
  }, (0, _core.jsx)(_ProductInstallmentsStep.ProductInstallmentsByProductStep, null))))));
};

exports.Simulator = Simulator;
process.env.NODE_ENV !== "production" ? Simulator.propTypes = propTypes : void 0;
Simulator.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Simulator",
  "props": {
    "open": {
      "type": {
        "name": "bool"
      },
      "required": true,
      "description": ""
    }
  }
};